<template>
    <div ref="photo" class="frisbuy-product-image">
        <GalleryBlur v-if="!contentIsLoaded" />
        <div class="frisbuy-similar-title" v-if="props.isSimilar">{{ props.similarGood }}</div>
    </div>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue';
import GalleryBlur from "@/components/popup/GalleryBlur.vue";

const props = defineProps<{ thumbUrl: string; isSimilar: boolean; similarGood?: boolean }>();

const photo = ref<HTMLDivElement | null>(null);
const contentIsLoaded = ref<boolean>(false);

watch(
    () => props.thumbUrl,
    (newThumbUrl) => {
        contentIsLoaded.value = false;

        const image = new Image();
        const loaded = () => {
            const { src: imageSource } = image;

            contentIsLoaded.value = true;
            if (!photo.value) return;

            (photo.value as HTMLDivElement).style.backgroundImage = `url(${imageSource})`;
        };

        const onError = () => {
            contentIsLoaded.value = true;
        };

        image.addEventListener("load", loaded);
        image.addEventListener("load", onError);

        if (newThumbUrl) {
            image.src = newThumbUrl;
        }
    },
    { immediate: true }
);
</script>